<!--级联选择器默认值-->
/*
级联选择器默认值回显传值方法
单选，传code字符串，
多选，传所有code以逗号','拼接的字符串；如：'112,221,3342'
注：code为所选中节点的code
使用 init 方法设置默认值
*/
<template>
  <div class="block">
    <el-cascader
      style="width: 100%;height: 100%"
      :options="options"
      :props="setMore"
      :show-all-levels="false"
      :size="setSize"
      placeholder="请选择"
      @change="selectChange"
      @focus="focus"
      @blur="blur"
      @expand-change="expandChange"
      v-model="checkedValue"
      clearable :disabled="isDisabled">
    </el-cascader>
  </div>
<!-- options属性指定选项数组即可渲染出一个级联选择器
props  配置选项
show-all-levels	输入框中是否显示选中值的完整路径
size	尺寸
placeholder	输入框占位文本
change	当绑定值变化时触发的事件
focus  当获取焦点时触发
blur  当失去焦点时触发
expand-change 当展开节点发生变化时触发 各父级选项值组成的数组
-->
</template>

<script>
    export default {
        name: 'Cascader',
        props: {
            setProps: {
                type: Object
            },
            setSize: {
                value: 'mini',
                type: String // medium / small / mini
            },
            isDisabled: {
                type: Boolean,
                value: false
            }
        },
        data() {
            return {
                showLevels: false, // 不显示完整路径
                setMore: {
                    multiple: false, // 多选
                    checkStrictly: false, // 父节点取消选中关联
                    value: 'value',
                    label: 'label',
                    children: 'children',
                    leaf: 'leaf'
                },
                options: [],
                checkedValue: [],
                oldSelectValue: null, // change事件中单选原始值
                oldRadioValue: null, // change事件中多选原始值
                selectValue: null, // 单选值
                radioValue: [], // 多选值
                selectObj: [], // 单选节点对象
                radioObj: [] // 多选节点对象
            }
        },
        mounted() {
            this.getAreaData()
        },
        methods: {
            // 数据重组
            init: function (val) { // 编辑时传入村庄的code码
                let _this = this
                if (this.setMore.multiple === true) {
                    // 多选

                    let arr = val.split(',') // 字符串分割成数组code
                    _this.radioValue = arr  // 多选值
                    let temp = []
                    // 对每一个选项进行重组
                    for (let i = 0; i < arr.length; i++) {
                        let nodeArr = _this.fitData(arr[i])
                        temp.push(nodeArr)
                    }
                    _this.checkedValue = temp
                } else {
                    // 单选
                    _this.checkedValue = _this.fitData(val) // 传入目标code,返回包含目标code及其父级联的code的数组
                    let tempArr = [val]
                    _this.selectObj = []
                    let temp = _this.getCascaderObj(tempArr, _this.options) // 传入code数组和options,返回节点数组对象

                    let length = temp.length - 1

                    _this.selectObj.push(temp[length]) // 单选节点对象
                    _this.selectValue = val  // 单选值

                }
            },
            // 车辆限制管辖区域
            carAreaData: function (val) {
                let temp = JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.orgTreeName)))
                this.options = temp.filter(item => item.code == val)
            },
           
            // 请求区划数据 *
            getAreaData: function () {
                if (!this.setSize) {
                    this.setSize = 'medium'
                }
                // 将传过来的setProps赋值给自己
                this.setMore = this.setProps
                let _this = this
              // 将本地缓存的数据赋值给options,渲染到级联选择器中
             // console.log(JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.orgTreeName))))
                _this.options = JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.orgTreeName)))

            },
            // 向父组建传值
            // type 为返回值类型 type==value 返回当前节点的code type==obj 返回当前节点对象
            sendToParent: function (type) {
                let _this = this
                if (_this.setMore.multiple === true) { // 多选
                    if (type === 'value') {
                        return _this.radioValue // 多选值
                    } else {
                        return _this.radioObj // 多选对象
                    }
                } else { // 单选
                    if (type === 'value') {
                        return _this.selectValue // 单选值
                    } else {
                        return _this.selectObj // 单选对象
                    }
                }
            },
            // 当选中节点变化时触发 选中节点的值
          // 级联显示的是name,返回的是code码: 父级code, 子级code
          // e 是返回的code
            selectChange: function (e) {
                this.selectObj = []
                this.selectValue = null
                this.radioObj = []
                this.radioValue = []
                let _this = this
                // 单选
                if (_this.setMore.multiple === false) {
                    _this.oldSelectValue = e // 将选中的code数组赋值给 change事件中单选原始值
                    _this.selectObj = [] // 单选节点对象置空

                  // let ap = _this.setMore['value']
                    let temp = _this.getCascaderObj(e, _this.options) // 返回选中级联的对象及其父对象的集合 [父级1, 父级2,....,子集]
                    let length = temp.length - 1 // 对应选中的子集index
                    _this.selectObj.push(temp[length]) // 将选中的子集对象赋值给单选节点对象
                    _this.selectValue = temp[length][_this.setMore['value']] // 将选中的子code赋值给单选值
                } else {
                    // 多选
                    _this.oldRadioValue = e // 将选中的code数组赋值给 change事件中多选原始值
                    _this.radioValue = [] // 多选值置空
                    _this.radioObj = [] // 多选节点对象置空
                    for (let itm of e) {
                        let temp = _this.getCascaderObj(itm, _this.options)
                        let length = temp.length - 1
                        _this.radioObj.push(temp[length])
                    }
                    for (let val of _this.radioObj) {
                        _this.radioValue.push(val[_this.setMore['value']])
                    }
                }
            },
            // 当展开节点发生变化时触发 各父级选项值组成的数组
            expandChange: function (e) {
            },
            // 当失去焦点时触发
            blur: function () {
            },
            // 当获取焦点时触发
            focus: function () {
            },
            // 遍历数据源，返回节点对象 // 传入一个code数组,tempArr, _this.options数据源
            getCascaderObj: function (val, opt) {

                let _this = this
                return val.map(function (value, index, array) {
                    for (let itm of opt) {
                        if (itm[_this.setMore['value']] === value) {
                            opt = itm.children
                            return itm
                        }
                    }
                    return null
                })
            },
            // 获取父组建默认值并组装数据
            fitData: function (data) {

                let arr = [] // 在递归时操作的数组
                let returnArr = [] // 存放结果的数组
                let depth = 0 // 定义全局层级
                function childrenEach(childrenData, depthN) {

                    for (let j = 0; j < childrenData.length; j++) {
                        depth = depthN // 将执行的层级赋值 到 全局层级
                        arr[depthN] = (childrenData[j].code)
                        if (childrenData[j].code === data) {
                            returnArr = arr.slice(0, depthN + 1) // 将目前匹配的数组，截断并保存到结果数组
                            break
                        } else {
                            if (childrenData[j].children) {
                                depth++
                                childrenEach(childrenData[j].children, depth)
                            }
                        }
                    }
                    return returnArr
                }
                return childrenEach(this.options, depth)
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cascader.vue